import styled from "styled-components";

export const Bar = styled.div`
  width: 100%;
  max-width: 1520px;
  border: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
  border-radius: 8px;
  margin-bottom: 18px;
  padding: 14px 16px;
  background: ${({ theme }) => theme.palette.colors.surfaceElevatedSoft};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 760px) {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const ContextText = styled.div`
  min-width: 0;
  color: ${({ theme }) => theme.palette.colors.muted};
  font-size: 14px;
  font-weight: 800;
  text-transform: uppercase;
`;

export const Title = styled.div`
  margin-top: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme }) => theme.palette.colors.text};
  font-size: 21px;
  line-height: 1.25;
  text-transform: none;
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const NavButton = styled.button`
  min-height: 42px;
  border: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
  border-radius: 8px;
  padding: 0 12px;
  background: ${({ theme }) => theme.palette.colors.surfaceElevated};
  color: ${({ theme }) => theme.palette.colors.text};
  cursor: pointer;
  font-size: 15px;
  font-weight: 800;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.48;
  }
`;
